export default __webpack_public_path__ + "static/media/icon-ic-check.71d400bf.svg";